import { formatRelative } from 'date-fns';
import { pt } from 'date-fns/locale';

const capitalize = (date: string) => date.charAt(0).toUpperCase() + date.substr(1);

export default (date: string) => capitalize(formatRelative(new Date(date.replace(/-/g, '/')), new Date(), { locale: pt }));